import http from '../http';

export const getPackingMaster = async () => {
  return http.get(`/packing-master`);
};

export const getLastCodePackingMaster = async () => {
  return http.get(`/packing-master/last-code`);
};

export const deletePackingMaster = async (id: number) => {
  return http.delete(`/packing-master/${id}`);
};

export const createPackingMaster = async (style: String) => {
  return http.post(`/packing-master`, { style });
};

export const getUnitMesure = async () => {
  return http.get(`/unit-measure`);
};

export const getLastCodeUnit = async () => {
  return http.get(`/unit-measure/last-code`);
};

export const deleteUnitMesure = async (id: number) => {
  return http.delete(`/unit-measure/${id}`);
};

export const createUnitMesure = async (unit: String) => {
  return http.post(`/unit-measure`, { unit });
};

export const deleteWaste = async (id: number) => {
  return http.delete(`/waste/${id}`);
};

export const getWastes = async (fullRes: boolean = false) => {
  return http.get(`/waste`, { returnFullResponse: fullRes });
};

export const getWasteForManagement = async (category: String, query: String) => {
  return http.get(`/waste/manage`, { params: { category, query } });
};

export const getWastesByParentId = async (parent_id: String) => {
  return http.get(`/waste/parent/${parent_id}`);
};

export const createWaste = async (
  name: String,
  wasteCode: String,
  parentPath: String,
  level: String
) => {
  return http.post(`/waste`, { name, wasteCode, parentPath, level });
};

export const checkWasteCode = async (wasteCode: String) => {
  return http.get(`/waste/check-waste-code/${wasteCode}`);
};

export const getDisposal = async () => {
  return http.get(`/disposal-site-master`);
};

export const getDisposalFullResponse = async () => {
  return http.get(`/disposal-site-master`, { returnFullResponse: true });
};

export const getLastCodeDisposal = async () => {
  return http.get(`/disposal-site-master/last-code`);
};

export const deleteDisposal = async (id: number) => {
  return http.delete(`/disposal-site-master/${id}`);
};

export const createDisposal = async (
  name: String,
  city: String,
  address1: String,
  address2: String,
  address3: String,
  licenseNumber: String,
  expireDate: String,
  method: String,
  capacity: String,
  subscriberNumber: String,
  manifestPermitNumber: String,
  requiredReport: boolean
) => {
  return http.post(`/disposal-site-master`, {
    name,
    city,
    address1,
    address2,
    address3,
    licenseNumber,
    expireDate,
    method,
    capacity,
    subscriberNumber,
    manifestPermitNumber,
    requiredReport
  });
};
